import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Observable } from 'rxjs';

import { BaseRendererComponent } from '../base-renderer/base-renderer.component';
import { LabelValue } from '../../../../models';

@Component({
  selector: 'app-select-renderer',
  templateUrl: './select-renderer.component.html',
  styleUrl: './select-renderer.component.scss',
  imports: [NgSelectComponent, FormsModule, AsyncPipe],
})
export class SelectRendererComponent extends BaseRendererComponent implements ICellRendererAngularComp {
  // The options this cell offers. `params.options` is either one observable for the whole
  // column (the usual case) or a function of the row, so a grid can offer a different list
  // per row - the Multi Product Create Variant column, whose variants depend on each row's
  // product type. Resolved here rather than in the template so the function runs once per
  // row, not once per change-detection pass.
  protected options$: Observable<LabelValue[]>;

  override agInit(params: ICellRendererParams): void {
    super.agInit(params);
    this.resolveOptions();
  }

  override refresh(params: ICellRendererParams): boolean {
    super.refresh(params);
    this.resolveOptions();
    return true;
  }

  public onChange(model: LabelValue) {
    this.params.node.setDataValue(this.colId, model?.value ?? null);
  }

  private resolveOptions() {
    const options = this.params?.options;
    this.options$ = typeof options === 'function' ? options(this.rowData) : options;
  }
}
